<template>
  <div align="center" v-if="params.data">
    <buttonComponent
      :icon="params.icon"
      :action="params.action"
      :title="params.title"
      :actionParams="params.data"
      :btnClass="params.btnClass"
    ></buttonComponent>
  </div>
</template>

<script type="text/javascript">
import Vue from "vue";
import buttonComponent from "../../button/buttonComponent.vue";

export default Vue.extend({
  components: {
    buttonComponent: buttonComponent
  }
});
</script>
